import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { ReactNode } from 'react';

interface EmptyTablePageProps {
  title: string;
  subtitle: ReactNode;
}
const EmptyTablePage = ({ title, subtitle }: EmptyTablePageProps) => (
  <ResponsiveDoqWithSpeechBubble
    doqType={DoqType.MISSING_ORG}
    title={title}
    message={subtitle}
  />
);

export { EmptyTablePage };
